module.exports = __webpack_public_path__ + "img/PHL.a61e5784.svg";